export const INVENTORY_TRANSACTIONLOG_LIST_REQUEST = 'INVENTORY_TRANSACTIONLOG_LIST_REQUEST';

export const INVENTORY_TRANSACTIONLOG_LIST = 'INVENTORY_TRANSACTIONLOG_LIST';

export const SET_TOTAL_COUNT = 'SET_TOTAL_COUNT';

export const SET_INVENTORY_TRANSACTIONLOG_PAGINATION = 'SET_INVENTORY_TRANSACTIONLOG_PAGINATION';

export const INVENTORY_TRANSACTIONLOG_PAGE_RESET = 'INVENTORY_TRANSACTIONLOG_PAGE_RESET';

export const ITEM_TRANSACTION_LOG_LIST_REQUEST = 'ITEM_TRANSACTION_LOG_LIST_REQUEST';
